import type { ActionType } from '@/types'
import { ACTION_TYPE_DEFINITIONS } from '@/constants/actions'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ActionTypeCard } from './ActionTypeCard'

interface ActionTypeSelectorProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  availableAP: number
  onSelectType: (type: ActionType) => void
}

export function ActionTypeSelector({
  open,
  onOpenChange,
  availableAP,
  onSelectType,
}: ActionTypeSelectorProps) {
  if (!open) return null

  const handleSelectType = (type: ActionType) => {
    onSelectType(type)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Select Action Type</DialogTitle>
          <DialogDescription>
            Choose an action to spend your party's action points. You have{' '}
            <span className="font-semibold">{availableAP} AP</span> available.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {ACTION_TYPE_DEFINITIONS.map((definition) => (
            <ActionTypeCard
              key={definition.type}
              definition={definition}
              availableAP={availableAP}
              onClick={() => handleSelectType(definition.type)}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
